import { defineStore } from "pinia";
import { api } from "@/shared/resource/apis/baseApi";
import { BANK } from "@/shared/resource/apis/endpoints";

export const useBankStore = defineStore("bank", {
  actions: {
    getBankDetails(id) {
      const response = api.get(BANK.GET_BY_ID(id));
      return response.data;
    },

    async addBank(payload) {
      const response = await api.post(BANK.GET, payload);
      return response.data;
    },

    async updateBank(id, payload) {
      const response = await api.put(BANK.UPDATE(id), payload);
      return response.data;
    },
  },
});
